import { render, staticRenderFns } from "./LabBaseAbstract.vue?vue&type=template&id=4b6de036&"
import script from "./LabBaseAbstract.vue?vue&type=script&lang=js&"
export * from "./LabBaseAbstract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports